// convex/lib/config/domains/integrations.ts

import {
  validatorIntegrationConnection,
  validatorIntegrationExecution,
  validatorIntegrationTrigger,
} from "../../../companies/integrations";
import type { DomainGroup, TableScope } from "../types";

/**
 * Integraciones (docs/analisis-integraciones.md): conexiones por empresa a
 * plugins del catalogo (Webhook, Slack, Notion...), triggers del bus de
 * eventos y su historial de ejecuciones. Crear/editar conexiones y triggers
 * pide los permisos de escritura del modulo (por defecto solo admins); ver
 * el historial, `canRead`. Conexiones y triggers son de la empresa (sin
 * sucursal): las credenciales son del workspace.
 */
export const integrationsDomain: DomainGroup = {
  id: "integrations",
  name: "Integraciones",
  description: "Conexiones con servicios externos",
  icon: "Plug",
  order: 25,
  status: "active",

  i18n: {
    namespace: "integrations",
    keys: {
      title: "integrations.title",
      description: "integrations.description",
    },
  },

  modules: [
    {
      id: "integrations",
      name: "Integraciones",
      description: "Webhooks, Slack, Notion y otros servicios conectados",
      icon: "Plug",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings/integrations"],
      navigation: {
        showInNav: true,
        contexts: ["settings"],
        navOrder: 9,
        status: "active",
      },
      i18n: {
        namespace: "integrations.integrations",
        keys: {
          title: "integrations.integrations.title",
          description: "integrations.integrations.description",
          longDescription: "integrations.integrations.longDescription",
          searchPlaceholder: "integrations.integrations.searchPlaceholder",
          emptyState: "integrations.integrations.emptyState",
          actions: {
            create: "integrations.integrations.actions.create",
            edit: "integrations.integrations.actions.edit",
            delete: "integrations.integrations.actions.delete",
            view: "integrations.integrations.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },
      tables: [
        {
          tableName: "integration_connections",
          schema: validatorIntegrationConnection,
          scope: "company" as TableScope,
          relations: [],
          searchFields: ["name"],
          hasStatusIndex: false,
          customRules: [],
        },
        {
          tableName: "integration_triggers",
          schema: validatorIntegrationTrigger,
          scope: "company" as TableScope,
          relations: [],
          searchFields: ["name"],
          hasStatusIndex: false,
          customRules: [],
        },
        {
          tableName: "integration_executions",
          schema: validatorIntegrationExecution,
          scope: "company" as TableScope,
          relations: [],
          searchFields: ["actionId"],
          hasStatusIndex: false,
          customRules: [],
        },
      ],
      readOnlyTables: [],
    },
  ],
};
